<template>
  <div class="age-distribution-chart">
    <div class="text-center mb-4">{{ title }}</div>
    <div class="row">
      <div class="col-md-6">
        <div class="text-center mb-3">Мэргэшсэн инженер</div>
        <apexchart
          type="bar"
          :options="miningEngineerOptions"
          :series="miningEngineerSeries"
          height="400"
        />
      </div>
      <div class="col-md-6">
        <div class="text-center mb-3">Зөвлөх инженер</div>
        <apexchart
          type="bar"
          :options="defenseEngineerOptions"
          :series="defenseEngineerSeries"
          height="400"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { request } from "@/api/all";

export default {
  name: "EduDistributionChart",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    title: {
      type: String,
      default: "Боловсролын түвшин"
    }
  },
  data() {
    return {
      miningEngineerSeries: [],
      defenseEngineerSeries: [],
      categories: [],
      miningEngineerOptions: {
        chart: {
          type: "bar",
          height: 380,
          stacked: true,
          toolbar: {
            show: false
          }
        },
        colors: ["#4299E1", "#FF69B4"],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "80%",
            borderRadius: 2
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        yaxis: {
          min: -150,
          max: 150,
          title: {
            text: "Боловсролын түвшин"
          }
        },
        tooltip: {
          shared: false,
          x: {
            formatter: function(val) {
              return val + " түвшин";
            }
          },
          y: {
            formatter: function(val) {
              return Math.abs(val);
            }
          }
        },
        xaxis: {
          categories: [],
          title: {
            text: "Үзүүлэлт"
          },
          labels: {
            formatter: function(val) {
              return Math.abs(Math.round(val));
            }
          }
        },
        legend: {
          position: "top"
        }
      },
      defenseEngineerOptions: {
        chart: {
          type: "bar",
          height: 380,
          stacked: true,
          toolbar: {
            show: false
          }
        },
        colors: ["#4299E1", "#FF69B4"],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "80%",
            borderRadius: 2
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        yaxis: {
          min: -150,
          max: 150,
          title: {
            text: "Боловсролын түвшин"
          }
        },
        tooltip: {
          shared: false,
          x: {
            formatter: function(val) {
              return val + " түвшин";
            }
          },
          y: {
            formatter: function(val) {
              return Math.abs(val);
            }
          }
        },
        xaxis: {
          categories: [],
          title: {
            text: "Үзүүлэлт"
          },
          labels: {
            formatter: function(val) {
              return Math.abs(Math.round(val));
            }
          }
        },
        legend: {
          position: "top"
        }
      }
    };
  },
  mounted() {
    this.loadData5();
    this.loadData6();
  },
  methods: {
    loadData5() {
      request({
        api: {
          url: "/reportV2/Export",
          method: "POST"
        },
        data: {
          procName: "egazar_chart7",
          exportMode: 2,
          params: []
        }
      }).then(res => {
        if (res != false) {
          // console.log(res);
          this.updateChartData(res.data, 5);
        }
      });
    },
    loadData6() {
      request({
        api: {
          url: "/reportV2/Export",
          method: "POST"
        },
        data: {
          procName: "egazar_chart8",
          exportMode: 2,
          params: []
        }
      }).then(res => {
        if (res != false) {
          // console.log(res);
          this.updateChartData(res.data, 6);
        }
      });
    },
    updateChartData(data, mode) {
      if (data && data.length > 0) {
        // Process age data to create population pyramid
        const ageGroups = this.groupByAge(data);
        const categories = Object.keys(ageGroups).sort(
          (a, b) => parseInt(a) - parseInt(b)
        );

        const maleData = [];
        const femaleData = [];

        categories.forEach(age => {
          const group = ageGroups[age];
          const maleCount = group["Эрэгтэй"] || 0;
          const femaleCount = group["Эмэгтэй"] || 0;

          maleData.push(maleCount);
          femaleData.push(-femaleCount); // Negative for left side of pyramid
        });

        const series = [
          {
            name: "Эрэгтэй",
            data: maleData
          },
          {
            name: "Эмэгтэй",
            data: femaleData
          }
        ];

        this.categories = categories;

        // Calculate max value for chart scaling
        const maxMale = Math.max(...maleData);
        const maxFemale = Math.max(...femaleData.map(Math.abs));
        const maxValue = Math.max(maxMale, maxFemale);
        const chartMax = Math.ceil(maxValue * 1.2); // Add 20% padding

        if (mode == 5) {
          this.miningEngineerSeries = series;
          // Update chart options to trigger reactivity
          this.miningEngineerOptions = {
            ...this.miningEngineerOptions,
            xaxis: {
              ...this.miningEngineerOptions.xaxis,
              categories: categories
            },
            yaxis: {
              ...this.miningEngineerOptions.yaxis,
              min: -chartMax,
              max: chartMax
            }
          };
        } else if (mode == 6) {
          this.defenseEngineerSeries = series;
          // Update chart options to trigger reactivity
          this.defenseEngineerOptions = {
            ...this.defenseEngineerOptions,
            xaxis: {
              ...this.defenseEngineerOptions.xaxis,
              categories: categories
            },
            yaxis: {
              ...this.defenseEngineerOptions.yaxis,
              min: -chartMax,
              max: chartMax
            }
          };
        }

        // Debug logging
        // console.log("Age groups:", ageGroups);
        // console.log("Categories:", categories);
        // console.log("Male data:", maleData);
        // console.log("Female data:", femaleData);
        // console.log("Series:", series);
      }
    },
    groupByAge(data) {
      const grouped = {};

      data.forEach(item => {
        const age = item.degree;
        const gender = item.gender;
        const count = parseInt(item.count);

        if (!grouped[age]) {
          grouped[age] = {};
        }

        if (!grouped[age][gender]) {
          grouped[age][gender] = 0;
        }

        grouped[age][gender] += count;
      });

      return grouped;
    }
  }
};
</script>

<style scoped>
.age-distribution-chart {
  padding: 20px;
}
</style>
